import Icon from '../components/Icon.vue'

Icon.register({
  'hand-pointer': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 240V336C448 339.1 447.6 342.2 446.9 345.2L414.9 481.2C410.7 499.2 394.6 512 376 512H168A40-40 0 0 0 135.7 495.5L7.7 319.5C-5.3 301.7-1.4 276.6 16.5 263.7 34.3 250.7 59.4 254.6 72.4 272.5L104 316V40C104 17.9 121.9 0 144 0S184 17.9 184 40V240H192V200C192 177.9 209.9 160 232 160S272 177.9 272 200V240H280V216C280 193.9 297.9 176 320 176S360 193.9 360 216V240H368C368 217.9 385.9 200 408 200S448 217.9 448 240zM192 320H184V416H192V320zM280 320H272V416H280V320zM368 320H360V416H368V320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-pointer.js
// module id = rgLZ
// module chunks = 144